<script lang="ts">
    import type {PublicStatsData} from '../../types';
    import {Bar} from 'svelte-chartjs';
    import {getLocalization} from 'core/svelte-context/context';
    import KpTitledSection from 'shared/layouts/KpTitledSection.svelte';
    import {
        BarElement,
        CategoryScale,
        Chart,
        Legend,
        LinearScale,
        Title,
        Tooltip
    } from 'chart.js';

    export let statsData: PublicStatsData;
    const localize = getLocalization();

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        barThickness: 'flex',
        plugins: {
            legend: {
                display: true
            },
            position: 'chartArea' as const
        }
    };

    function generateLoginsAndEntersData(data: PublicStatsData) {
        return {
            labels: data.stats.result.entersAndLoginsCounts.counts.map((enterOrLogin) => enterOrLogin.name),
            datasets: [
                {
                    label: localize(/* @kp-localization statistiky.pocetVstupu */ 'statistiky.pocetVstupu'),
                    backgroundColor: '#2259e3BB',
                    borderColor: '#2259e3',
                    borderWidth: 1,
                    data: data.stats.result.entersAndLoginsCounts.counts.map((enterOrLogin) => enterOrLogin.value.first)
                },
                {
                    label: localize(/* @kp-localization statistiky.zTohoPrihlasenych */ 'statistiky.zTohoPrihlasenych'),
                    backgroundColor: '#f32746BB',
                    borderColor: '#f32746',
                    borderWidth: 1,
                    data: data.stats.result.entersAndLoginsCounts.counts.map((enterOrLogin) => enterOrLogin.value.second)
                }
            ]
        }
    }

    Chart.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);
</script>

<KpTitledSection additionalClasses="stats-logins-and-enters-graph"
                 title="{localize(/* @kp-localization statistiky.vstupyAPrihlaseniDoSystemu */ 'statistiky.vstupyAPrihlaseniDoSystemu')}"
                 headingType="h3">

    <div class="graph-container">
        <Bar data="{generateLoginsAndEntersData(statsData)}" {options}/>
    </div>
</KpTitledSection>

<style lang="less">
    .graph-container {
        width: 100%;
        height: 360px;
    }
</style>